const angular = require('angular');
const app = angular.module('learn-directives');
const moment = require('moment');
/**
 * Defines the category selector directive
 * @argument {Categories} Categories the resource defined to manage Categories
 */
app.directive('categorySelector', ['Categories', '$q', function (Categories, $q) {
  return {
    restrict: 'E',
    scope: {
      start: '=',
      restrictions: '=',
      onQuery: '&',
      placeholder: '='
    },
    template: require('../../templates/directives/category-selector.html'),
    controller: ['$scope', function ($scope) {
      var self = this;
      self.queryIds = {};
      self.queries = [];
      self.grades = {};
      self.org_levels = {};
      self.teams = {};
      self.departments = {};
      self.locations = {};
      self.categories = {};
      self.activeFilter = '';
      self.placeholder = $scope.placeholder || 'Search';
      self.searchString = '';

      var getLineage = function(id, type) {
        var items = [id];
        var children = [];
        var grandChildren = [];

        var addTo = function(id) {
          children.push(id);
          var main = self[type][id];
          if (!main || !main.children || !main.children.length) {
            return;
          }
          for (var i = 0; i < main.children.length; i++) {
            grandChildren.push(main.children[i]);
          }
        };

        if (!self[type][id] || !self[type][id].children || !self[type][id].children.length) {
          return items;
        }

        for (var i = 0; i < self[type][id].children.length; i++) {
          addTo(self[type][id].children[i], children);
        }

        return items.concat(children, grandChildren);
      };

      self.updateQuery = function(tag) {
        var item = {};
        if (tag && tag._id) {
          item._id = tag._id;
          $scope.onQuery({query: item});
          self.searchString = '';
        }
      };

      // ------------- start ngTag triggered actions ------------
      self.addingTag = function($tag) {
        self.updateQuery($tag);
        return false;
      };
      // ------------- End ngTag triggered actions ------------


      var legacyName = function(item, type) {
        var name = '';
        var parent;
        var parentName;
        var papa;
        var papaName;

        item.legacyName = item.name;

        if (item.parent) {
          parent = self[type][item.parent];
          parentName = parent.name + ' -> ';
          papa = parent.parent;
          item.legacyName = parentName + item.name;
        }

        if (papa) {
          papa = self[type][papa];
          papaName = papa.name + ' -> ';
          item.legacyName = papaName + parentName + item.name;
        }
      };

      self.sortCategories = function(data) {
        angular.forEach(data, function(cat) {
          if (cat.grade) {
            self.grades[cat._id] = cat;
          }
          if (cat.org_level) {
            self.org_levels[cat._id] = cat;
          }
          if (cat.team) {
            self.teams[cat._id] = cat;
          }
          if (cat.department) {
            self.departments[cat._id] = cat;
          }
          if (cat.location) {
            self.locations[cat._id] = cat;
          }
          if (cat.category) {
            self.categories[cat._id] = cat;
          }
        });
        for (var grade in self.grades) {
          legacyName(self.grades[grade], 'grades');
        }
        for (var level in self.org_levels) {
          legacyName(self.org_levels[level], 'org_levels');
        }
        for (var team in self.teams) {
          legacyName(self.teams[team], 'teams');
        }
        for (var dep in self.departments) {
          legacyName(self.departments[dep], 'departments');
        }
        for (var loc in self.locations) {
          legacyName(self.locations[loc], 'locations');
        }
        for (var item in self.categories) {
          legacyName(self.categories[item], 'categories');
        }
      };

      self.getOptions = function(input) {
        var deferred = $q.defer();

        input = input ? input.toLowerCase() : '';
        var typeRestriction = null;
        var idRestriction = '';
        if ($scope.restrictions && $scope.restrictions._id) {
          idRestriction = $scope.restrictions._id.toString();
        }
        if ($scope.restrictions && $scope.restrictions.type) {
          typeRestriction = $scope.restrictions.type;
        }
        var placeholders = {
          grades: {name: 'Grades', text: 'Grades', _id: 'grades', placeholder: true},
          org_levels: {name: 'Level', text: 'Organizational Level', _id: 'levels', placeholder: true},
          teams: {name: 'Teams', text: 'Teams', _id: 'teams', placeholder: true},
          departments: {name: 'Departments', text: 'Departments', _id: 'departments', placeholder: true},
          locations: {name: 'Locations', text: 'Locations', _id: 'locations', placeholder: true},
          categories: {name: 'Categories', text: 'Categories', _id: 'categories', placeholder: true}
        };
        var addedItems = {
          grades: false,
          org_levels: false,
          teams: false,
          departments: false,
          locations: false,
          categories: false
        };
        var items = [];
        // Add grades to options
        for (var grade in self.grades) {
          if (typeRestriction && typeRestriction !== 'grade') {
            break;
          }
          if (new RegExp(input).test(self.grades[grade].name.toLowerCase()) && !self.queryIds[self.grades[grade]._id]) {
            if (idRestriction && self.grades[grade]._id && self.grades[grade]._id.toString() === idRestriction) {
              continue;
            }
            if (!addedItems.grades) {
              items.push(placeholders.grades);
              addedItems.grades = true;
            }
            items.push({
              name: self.grades[grade].name,
              text: self.grades[grade].legacyName,
              _id: self.grades[grade]._id,
              type: 'grade'
            });
          }
        } // ----------
        // Add org_levels to options
        for (var org_level in self.org_levels) {
          if (typeRestriction && typeRestriction !== 'org_level') {
            break;
          }
          if (new RegExp(input).test(self.org_levels[org_level].name.toLowerCase()) && !self.queryIds[self.org_levels[org_level]._id]) {
            if (idRestriction && self.org_levels[org_level]._id && self.org_levels[org_level]._id.toString() === idRestriction) {
              continue;
            }
            if (!addedItems.org_levels) {
              items.push(placeholders.org_levels);
              addedItems.org_levels = true;
            }
            items.push({
              name: self.org_levels[org_level].name,
              text: self.org_levels[org_level].legacyName,
              _id: self.org_levels[org_level]._id,
              type: 'org_level'
            });
          }
        } // ----------
        // Add teams to options
        for (var team in self.teams) {
          if (typeRestriction && typeRestriction !== 'team') {
            break;
          }
          if (new RegExp(input).test(self.teams[team].name.toLowerCase()) && !self.queryIds[self.teams[team]._id]) {
            if (idRestriction && self.teams[team]._id && self.teams[team]._id.toString() === idRestriction) {
              continue;
            }
            if (!addedItems.teams) {
              items.push(placeholders.teams);
              addedItems.teams = true;
            }
            items.push({
              name: self.teams[team].name,
              text: self.teams[team].legacyName,
              _id: self.teams[team]._id,
              type: 'team'
            });
          }
        } // ----------
        // Add departments to options
        for (var dep in self.departments) {
          if (typeRestriction && typeRestriction !== 'department') {
            break;
          }
          if (new RegExp(input).test(self.departments[dep].name.toLowerCase()) && !self.queryIds[self.departments[dep]._id]) {
            if (idRestriction && self.departments[dep]._id && self.departments[dep]._id.toString() === idRestriction) {
              continue;
            }
            if (!addedItems.departments) {
              items.push(placeholders.departments);
              addedItems.departments = true;
            }
            items.push({
              name: self.departments[dep].name,
              text: self.departments[dep].legacyName,
              _id: self.departments[dep]._id,
              type: 'department'
            });
          }
        }
        // Add locations to options
        for (var loc in self.locations) {
          if (typeRestriction && typeRestriction !== 'location') {
            break;
          }
          if (new RegExp(input).test(self.locations[loc].name.toLowerCase()) && !self.queryIds[self.locations[loc]._id]) {
            if (idRestriction && self.locations[loc]._id && self.locations[loc]._id.toString() === idRestriction) {
              continue;
            }
            if (!addedItems.locations) {
              items.push(placeholders.locations);
              addedItems.locations = true;
            }
            items.push({
              name: self.locations[loc].name,
              text: self.locations[loc].legacyName,
              _id: self.locations[loc]._id,
              type: 'location'
            });
          }
        }
        for (var cat in self.categories) {
          if (typeRestriction && typeRestriction !== 'category') {
            break;
          }
          if (new RegExp(input).test(self.categories[cat].name.toLowerCase()) && !self.queryIds[self.categories[cat]._id]) {
            if (idRestriction && self.categories[cat]._id && self.categories[cat]._id.toString() === idRestriction) {
              continue;
            }
            if (!addedItems.categories) {
              items.push(placeholders.categories);
              addedItems.categories = true;
            }
            items.push({
              name: self.categories[cat].name,
              text: self.categories[cat].legacyName,
              _id: self.categories[cat]._id,
              type: 'category'
            });
          }
        }

        deferred.resolve(items);

        return deferred.promise;
      };

      self.initialize = function() {
        self.loading = true;
        self.placeholder = 'Loading..';
        Categories.find({
          sort: 'name,1'
        }).$promise
        .then(function(data) {
          self.sortCategories(data);
          self.loading = false;
          self.placeholder = $scope.placeholder || 'Search';
        });
      };

      if ($scope.start) {
        self.initialize();
        return;
      }

      var watchShow = $scope.$watch('start', function(newVal, oldVal) {
        if (newVal) {
          self.initialize();
          watchShow();
        }
      });
    }],
    controllerAs: 'selector'
  };
}]);